import React, {FC, ReactNode} from 'react'

import {Box, SxProps, Theme, useTheme} from '@mui/material'

export const MOBILE_STICKY_HEIGHT = '88px'

interface MobileStickyActionsProps {
  children: ReactNode
  desktopMt?: number
  sx?: SxProps<Theme>
}

const MobileStickyActions: FC<MobileStickyActionsProps> = ({
  children,
  desktopMt = 6,
  sx,
}) => {
  const theme = useTheme()
  return (
    <Box
      sx={{
        position: {xs: 'fixed', md: 'static'},
        bottom: 0,
        left: 0,
        right: 0,
        padding: {xs: 2, md: 0},
        mt: {xs: 0, md: desktopMt},
        backgroundColor: {xs: '#FAFAFA', md: 'transparent'},
        borderTop: {xs: '1px solid #EDEDED', md: 'none'},
        zIndex: {xs: theme.zIndex.appBar, md: 'auto'},
        ...sx,
      }}
    >
      {children}
    </Box>
  )
}

export default MobileStickyActions
